@if (!isStorefront()) {
  <app-header></app-header>
}
<router-outlet></router-outlet>
@if (!isStorefront()) {
  <app-footer></app-footer>
  <app-go-to-top></app-go-to-top>
}
